/**
 * Created by Jan on 17.09.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.Modals;

        (function (Modals, $, undefined) {
            if(Lfl.Files.isLoadedAlready(Lfl.Modals, 'AjaxLoadedModalOpeningElementHandler')) {
                return;
            }
            
            /*
            |===========================================================================================================
            | Class definition
            |===========================================================================================================
            */

            /**
             * Encapsulates javascript logic associated with asynchronous loading and opening of modals loaded from
             * server when certain element is clicked.
             * @memberOf Lfl.Modals
             * @lends Lfl.Modals.AjaxLoadedModalOpeningElementHandler
             * @constructor
             */
            Lfl.Modals.AjaxLoadedModalOpeningElementHandler = function($element, url) {
                /*
                |-------------------------------------------------------------------------------------------------------------------
                | Construction
                |-------------------------------------------------------------------------------------------------------------------
                */

                var animationHandler = LoadingAnimator.getAnimationHandlerFor($element);
                var loader = new Lfl.Modals.DialogLoader(url);
                var displayLoading = true;
                /**
                 * An additional action that should be performed on click.
                 */
                var clientOnClickAction = function () {};
                var parameters = {};
    
                /*
                |-----------------------------------------------------------------------------------------------------------
                | Public methods
                |-----------------------------------------------------------------------------------------------------------
                */

                /**
                 *
                 * @param shouldDisplayLoading
                 * @returns {Lfl.Modals.AjaxLoadedModalOpeningElementHandler}
                 */
                this.setDisplayLoading = function (shouldDisplayLoading) {
                    displayLoading = shouldDisplayLoading;
                    return this;
                };

                /**
                 *
                 * @param theParameters
                 * @returns {Lfl.Modals.AjaxLoadedModalOpeningElementHandler}
                 */
                this.setParameters = function (theParameters) {
                    parameters = theParameters;
                    return this;
                };

                /**
                 *
                 * @param {function} theAction
                 */
                this.setOnClickAction = function (theAction) {
                    clientOnClickAction = theAction;
                };
    
                
                /**
                 * Activates the click handling.
                 */      
                this.activate = function() {
                    Lfl.Events.ClickVsDragDistinguisher.registerOnClickButNotDragAction({
                        $element: $element,
                        action: handleClick
                    });

                };
    
                /*
                |-----------------------------------------------------------------------------------------------------------
                | Private methods
                |-----------------------------------------------------------------------------------------------------------
                */

                function handleClick (event) {
                    /*
                     |-------------------------------------------------------------------------
                     | First see if the client code allows the click. */
                    if(clientOnClickAction(event) === false) {
                        return;
                    }

                    /*
                     |-------------------------------------------------------------------------
                     | Consume the event */
                    // TODO - in the future it might be necessary "onlyReactToLeftClick", "consumeMouseClick" and
                    // "closeTooltipsAndPopovers" as instance fields to enable modification of this behaviour.

                    // Only react to left mouse click
                    // http://stackoverflow.com/questions/1206203/how-to-distinguish-between-left-and-right-mouse-click-with-jquery
                    if(event.which !== 1 ) {
                        return;
                    }

                    // First we let other listeners know that this click was consumed by this handler.
                    Lfl.Events.EventDataModifier.setMouseupWasConsumed(event);

                    /*
                     |-------------------------------------------------------------------------
                     | Animation */

                    animationHandler.animateElement();

                    /*
                     |-------------------------------------------------------------------------
                     | Load */
                    loader.loadAndOpenDialog(
                        {
                            callbacks: {
                                failure: animationHandler.loadingFinishedCallback,
                                success: animationHandler.loadingFinishedCallback
                            },
                            parameters: parameters
                        }
                    );
                }
            };
        }(Lfl.Modals = Lfl.Modals || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

